import TravelerProfileBucketListContainer from './traveler-profile-bucket-list-container';

export type { TravelerBucketListContainerProps } from './traveler-profile-bucket-list-container';
export default TravelerProfileBucketListContainer;
